import type {
  TenantEntity,
  TenantProfileEntity,
} from '@ts-max/car-export-api-sdk';

export type TenantBranding = {
  description: string;
  name: string;
};

export function resolveTenantBranding(options: {
  pageTitle?: string;
  profile?: TenantProfileEntity;
  tenant?: TenantEntity;
}): TenantBranding {
  const { pageTitle, profile, tenant } = options;

  return {
    description: profile?.description || tenant?.description || pageTitle || '',
    name: profile?.name || tenant?.name || '汽车出口移动端',
  };
}
